const CARD_HISTORY_FIELD_HIRE_DATE = 'hireDate';
const CARD_HISTORY_FIELD_ACTIVATION_DATE = 'activationDate';
const CARD_HISTORY_FIELD_DELIVERY_DATE = 'deliveryDate';
const CARD_HISTORY_FIELD_STAMP_PENDING_DATE = 'stampPendingDate';
const CARD_HISTORY_FIELD_PREVIOUS_CARD_LIMIT = 'previousCardLimit';
const CARD_HISTORY_FIELD_LAST_EDIT_DATE = 'lastEditDate';
const CARD_HISTORY_FIELD_PIN_EDIT_DATE_ATM = 'PINEditDateATM';
const CARD_HISTORY_FIELD_PIN_EDIT_DATE_WEB_APP = 'PINEditDateWebApp';
const CARD_HISTORY_FIELD_PIN_RESET_DATE = 'PINResetDate';
const CARD_HISTORY_FIELD_BLOCKING_DATE = 'blockingDate';
const CARD_HISTORY_FIELD_WITHDRAWAL_DATE = 'withdrawalDate';


module.exports = {
    CARD_HISTORY_FIELD_HIRE_DATE,
    CARD_HISTORY_FIELD_ACTIVATION_DATE,
    CARD_HISTORY_FIELD_DELIVERY_DATE,
    CARD_HISTORY_FIELD_STAMP_PENDING_DATE,
    CARD_HISTORY_FIELD_PREVIOUS_CARD_LIMIT,
    CARD_HISTORY_FIELD_LAST_EDIT_DATE,
    CARD_HISTORY_FIELD_PIN_EDIT_DATE_ATM,
    CARD_HISTORY_FIELD_PIN_EDIT_DATE_WEB_APP,
    CARD_HISTORY_FIELD_PIN_RESET_DATE,
    CARD_HISTORY_FIELD_BLOCKING_DATE,
    CARD_HISTORY_FIELD_WITHDRAWAL_DATE,
}
